import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RouterProvider } from '@tanstack/react-router';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { useAuth } from '@/features/auth';
import { router } from '@/router';
export function App() {
    const auth = useAuth();
    if (auth.isLoading)
        return null;
    // Update router context synchronously before RouterProvider renders,
    // so route guards always see the current auth state.
    router.update({
        context: {
            auth: {
                isAuthenticated: auth.isAuthenticated,
                isAdmin: auth.isAdmin,
                onboardingComplete: auth.onboardingComplete,
                userId: auth.user?.userId ?? null,
                defaultPartyId: auth.user?.defaultPartyId ?? null,
            },
        },
    });
    return (_jsxs(_Fragment, { children: [_jsx(RouterProvider, { router: router }), import.meta.env.DEV && _jsx(ReactQueryDevtools, { initialIsOpen: false }), import.meta.env.DEV && _jsx(TanStackRouterDevtools, { router: router, initialIsOpen: false })] }));
}
